import { render, staticRenderFns } from "./BtnLabel.vue?vue&type=template&id=a3849adc"
import script from "./BtnLabel.vue?vue&type=script&lang=js"
export * from "./BtnLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports